/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Registereddesc22Inputs */

const id_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mungkin perlu beberapa jam hingga Anda ditambahkan secara manual ke daftar penguji. Setelah ditambahkan, Anda dapat bergabung dengan beta di sini:`)
};

const ms_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mungkin mengambil masa beberapa jam sehingga anda ditambah secara manual ke senarai penguji. Setelah ditambah, anda boleh menyertai beta di sini:`)
};

const da_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det kan tage et par timer før du bliver manuelt tilføjet til testerlisten. Når du er tilføjet, kan du deltage i betaen her:`)
};

const de_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es kann einige Stunden dauern, bis Sie manuell zur Testerliste hinzugefügt werden. Sobald Sie hinzugefügt wurden, können Sie hier an der Beta teilnehmen:`)
};

const en_us2_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It may take a few hours until you are manually added to the testers list. Once added, you can join the beta here:`)
};

const es_es2_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puede tardar unas horas hasta que se te añada manualmente a la lista de testers. Una vez añadido, puedes unirte a la beta aquí:`)
};

const es_mx2_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puede tardar unas horas hasta que seas agregado manualmente a la lista de testers. Una vez agregado, puedes unirte a la beta aquí:`)
};

const fil_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maaaring tumagal ng ilang oras hanggang ikaw ay manu-manong idagdag sa listahan ng mga tester. Kapag naidagdag, maaari kang sumali sa beta dito:`)
};

const fr_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ajout manuel à la liste des testeurs peut prendre quelques heures. Une fois ajouté, vous pouvez rejoindre la bêta ici :`)
};

const it_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrebbero volerci alcune ore prima che tu venga aggiunto manualmente all'elenco dei tester. Una volta aggiunto, puoi partecipare alla beta qui:`)
};

const hu_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eltarthat néhány óráig, amíg manuálisan hozzáadnak a tesztelők listájához. Ha hozzáadtak, itt csatlakozhatsz a bétához:`)
};

const nl_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het kan een paar uur duren voordat je handmatig wordt toegevoegd aan de testerlijst. Zodra je bent toegevoegd, kun je hier deelnemen aan de bèta:`)
};

const no_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det kan ta noen timer før du blir manuelt lagt til i testerlisten. Når du er lagt til, kan du bli med i betaen her:`)
};

const pl_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Może minąć kilka godzin, zanim zostaniesz ręcznie dodany do listy testerów. Po dodaniu możesz dołączyć do bety tutaj:`)
};

const pt_br2_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It may take a few hours until you are manually added to the testers list. Once added, you can join the beta here:`)
};

const pt_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode levar algumas horas até ser adicionado manualmente à lista de testers. Depois de adicionado, pode juntar-se à beta aqui:`)
};

const ro_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este posibil să dureze câteva ore până când vei fi adăugat manual pe lista de testeri. Odată adăugat, te poți alătura betai aici:`)
};

const fi_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saattaa kestää muutaman tunnin, ennen kuin sinut lisätään manuaalisesti testaajien listalle. Kun olet lisätty, voit liittyä betaan täällä:`)
};

const sv_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det kan ta några timmar tills du läggs till manuellt i testlistan. När du har lagts till kan du gå med i betan här:`)
};

const vi_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có thể mất vài giờ cho đến khi bạn được thêm thủ công vào danh sách người thử nghiệm. Sau khi được thêm, bạn có thể tham gia beta tại đây:`)
};

const tr_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test uzmanları listesine manuel olarak eklenmeniz birkaç saat sürebilir. Eklendikten sonra beta'ya buradan katılabilirsiniz:`)
};

const cs_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Může trvat několik hodin, než budete ručně přidáni do seznamu testerů. Po přidání se můžete připojit k beta verzi zde:`)
};

const bg_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Може да отнеме няколко часа, докато бъдете ръчно добавени към списъка на тестерите. След като бъдете добавени, можете да се присъедините към бета версията тук:`)
};

const ru_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Может пройти несколько часов, пока вас вручную добавят в список тестировщиков. После добавления вы можете присоединиться к бета-тесту здесь:`)
};

const uk_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Це може зайняти кілька годин, доки вас не додадуть до списку тестувальників. Після додавання ви зможете приєднатися до бета-версії тут:`)
};

const ar_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قد يستغرق الأمر بضع ساعات حتى تتم إضافتك يدويًا إلى قائمة المختبرين. بمجرد الإضافة، يمكنك الانضمام إلى الإصدار التجريبي هنا:`)
};

const hi_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुछ घंटे लग सकते हैं।`)
};

const th_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อาจใช้เวลาสองสามชั่วโมงจนกว่าคุณจะถูกเพิ่มในรายชื่อผู้ทดสอบด้วยตนเอง เมื่อเพิ่มแล้ว คุณสามารถเข้าร่วมเบต้าได้ที่นี่:`)
};

const ja_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テスターリストに手動で追加されるまで数時間かかる場合があります。追加され次第、こちらからベータ版に参加できます：`)
};

const zh_cn2_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It may take a few hours until you are manually added to the testers list. Once added, you can join the beta here:`)
};

const zh_hant1_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It may take a few hours until you are manually added to the testers list. Once added, you can join the beta here:`)
};

const ko_forms_androidbeta_registereddesc22 = /** @type {(inputs: Forms_Androidbeta_Registereddesc22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It may take a few hours until you are manually added to the testers list. Once added, you can join the beta here:`)
};

/**
* | output |
* | --- |
* | "It may take a few hours until you are manually added to the testers list. Once added, you can join the beta here:" |
*
* @param {Forms_Androidbeta_Registereddesc22Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_registereddesc22 = /** @type {((inputs?: Forms_Androidbeta_Registereddesc22Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Registereddesc22Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_registereddesc22(inputs)
	if (locale === "ms") return ms_forms_androidbeta_registereddesc22(inputs)
	if (locale === "da") return da_forms_androidbeta_registereddesc22(inputs)
	if (locale === "de") return de_forms_androidbeta_registereddesc22(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_registereddesc22(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_registereddesc22(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_registereddesc22(inputs)
	if (locale === "fil") return fil_forms_androidbeta_registereddesc22(inputs)
	if (locale === "fr") return fr_forms_androidbeta_registereddesc22(inputs)
	if (locale === "it") return it_forms_androidbeta_registereddesc22(inputs)
	if (locale === "hu") return hu_forms_androidbeta_registereddesc22(inputs)
	if (locale === "nl") return nl_forms_androidbeta_registereddesc22(inputs)
	if (locale === "no") return no_forms_androidbeta_registereddesc22(inputs)
	if (locale === "pl") return pl_forms_androidbeta_registereddesc22(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_registereddesc22(inputs)
	if (locale === "pt") return pt_forms_androidbeta_registereddesc22(inputs)
	if (locale === "ro") return ro_forms_androidbeta_registereddesc22(inputs)
	if (locale === "fi") return fi_forms_androidbeta_registereddesc22(inputs)
	if (locale === "sv") return sv_forms_androidbeta_registereddesc22(inputs)
	if (locale === "vi") return vi_forms_androidbeta_registereddesc22(inputs)
	if (locale === "tr") return tr_forms_androidbeta_registereddesc22(inputs)
	if (locale === "cs") return cs_forms_androidbeta_registereddesc22(inputs)
	if (locale === "bg") return bg_forms_androidbeta_registereddesc22(inputs)
	if (locale === "ru") return ru_forms_androidbeta_registereddesc22(inputs)
	if (locale === "uk") return uk_forms_androidbeta_registereddesc22(inputs)
	if (locale === "ar") return ar_forms_androidbeta_registereddesc22(inputs)
	if (locale === "hi") return hi_forms_androidbeta_registereddesc22(inputs)
	if (locale === "th") return th_forms_androidbeta_registereddesc22(inputs)
	if (locale === "ja") return ja_forms_androidbeta_registereddesc22(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_registereddesc22(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_registereddesc22(inputs)
	return ko_forms_androidbeta_registereddesc22(inputs)
});
export { forms_androidbeta_registereddesc22 as "forms.androidBeta.registeredDesc2" }